const API_URL = process.env.VUE_APP_API_ADM_URL;
const SECRET  = process.env.VUE_APP_PORTAL_WEBHOOK_SECRET || '';

// Resolve o owner ID do env — suporta inteiro simples ("22") e JSON array ("[22,25]").
// No segundo caso retorna null: o caller deve obter o ID de outra fonte (state.auth.ownerId).
export function resolveOwnerIdFromEnv() {
    const raw = process.env.VUE_APP_OWNER_ID;
    if (!raw) return null;
    try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) return null;   // array → não podemos escolher um único ID aqui
        return parseInt(parsed) || null;
    } catch {
        return parseInt(raw) || null;
    }
}

function beacon(endpoint, payload) {
    const url  = API_URL + endpoint;
    const blob = new Blob([JSON.stringify({ ...payload, secret: SECRET })], {
        type: 'application/json',
    });
    navigator.sendBeacon(url, blob);
}

export function sendAbandonmentBeacon(debtorId, ownerId, phoneNumber, eventType) {
    if (!debtorId || !ownerId) return;
    beacon('portal-event/abandonment', { debtorId, ownerId, phoneNumber: phoneNumber || null, eventType });
}

export function sendAgreementCompletedBeacon(debtorId, ownerId) {
    if (!debtorId || !ownerId) return;
    beacon('portal-event/agreement-completed', { debtorId, ownerId });
}
